import 'css-chunksrc/client/pages/projectPage/synthesisPage/styles.scss';export default {
  "synthesisPage": "_synthesisPage_1u28x_1",
  "projectModel": "_projectModel_1u28x_9",
  "header": "_header_1u28x_13",
  "strategicScore": "_strategicScore_1u28x_20",
  "icon": "_icon_1u28x_28",
  "weatherReport": "_weatherReport_1u28x_33",
  "main": "_main_1u28x_42",
  "row": "_row_1u28x_49",
  "reports": "_reports_1u28x_58",
  "descriptionSection": "_descriptionSection_1u28x_62",
  "monitoringSection": "_monitoringSection_1u28x_66",
  "milestonesSection": "_milestonesSection_1u28x_70",
  "milestones": "_milestones_1u28x_70",
  "description": "_description_1u28x_62",
  "descriptionParagraph": "_descriptionParagraph_1u28x_87",
  "tasks": "_tasks_1u28x_95",
  "taskMain": "_taskMain_1u28x_101",
  "upComingTasksTitle": "_upComingTasksTitle_1u28x_107",
  "upComingTasks": "_upComingTasks_1u28x_107",
  "upComingTasksNumber": "_upComingTasksNumber_1u28x_118",
  "overDueTasksTitle": "_overDueTasksTitle_1u28x_127",
  "overDueTasks": "_overDueTasks_1u28x_127",
  "overDueTasksNumber": "_overDueTasksNumber_1u28x_138",
  "monitoring": "_monitoring_1u28x_66",
  "monitoringMain": "_monitoringMain_1u28x_157",
  "editProjectStrategicAxisIconBox": "_editProjectStrategicAxisIconBox_1u28x_163",
  "editProjectStrategicAxisIcon": "_editProjectStrategicAxisIcon_1u28x_163"
};